import ShareIcon from "@/assets/images/icons/share.svg?inline";
import LinkIcon from "@/assets/images/icons/link.svg?inline";
import FacebookIcon from "@/assets/images/icons/facebook.svg?inline";
import LinkedinIcon from "@/assets/images/icons/linkedin.svg?inline";
import MailIcon from "@/assets/images/icons/mail.svg?inline";

export default {
  name: "share-dropdown",

  data() {
    return {
      isShowDropdown: false,
      copyLinkLabel: "Copy Link",
      linkCode: ""
    };
  },

  props: ["title"],

  mounted: function() {
    this.linkCode = window.location;
  },

  computed: {
    sharingOptions() {
      return { url: this.linkCode.href, title: this.title };
    }
  },

  methods: {
    copyLinkCode() {
      let linkToCopy = document.querySelector("#link-code");

      linkToCopy.setAttribute("type", "text");
      linkToCopy.select();

      try {
        var successful = document.execCommand("copy");
        this.copyLinkLabel = "Copied Link";
      } catch (err) {
        this.copyLinkLabel = "Unable to copy";
      }

      /* unselect the range */
      linkToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },

    closeDropdown() {
      this.isShowDropdown = false;
    }
  },

  components: {
    ShareIcon,
    LinkIcon,
    FacebookIcon,
    LinkedinIcon,
    MailIcon
  }
};
